import React, { useCallback, useEffect, useState } from 'react';
import { TrendingUp, Clock, ArrowDownLeft, ArrowUpRight } from 'lucide-react';
import { apiCall } from '../../utils/api';
import { useLiveRefresh } from '../../hooks/useLiveRefresh';

const fmt = (v) => `$${Number(v || 0).toFixed(2)}`;

/**
 * Compact worker financial summary — every number comes from the
 * centralized Financial Engine via /api/finance/summary.
 */
export default function FinancialSummaryCard() {
  const [summary, setSummary] = useState(null);

  const load = useCallback(() => {
    apiCall('/api/finance/summary')
      .then((d) => setSummary(d.summary))
      .catch(() => {});
  }, []);

  useEffect(() => { load(); }, [load]);
  useLiveRefresh(['finance', 'wallet', 'payroll'], load);

  if (!summary) return null;

  const tiles = [
    { label: 'Lifetime Earnings', value: summary.lifetime_earnings, Icon: TrendingUp, tone: 'text-emerald-600 bg-emerald-50', testid: 'finance-lifetime-earnings' },
    { label: 'Pending Payroll', value: summary.pending_balance, Icon: Clock, tone: 'text-amber-600 bg-amber-50', testid: 'finance-pending-payroll' },
    { label: 'Deposits', value: summary.lifetime_deposits, Icon: ArrowDownLeft, tone: 'text-blue-600 bg-blue-50', testid: 'finance-lifetime-deposits' },
    { label: 'Withdrawals', value: summary.lifetime_withdrawals, Icon: ArrowUpRight, tone: 'text-rose-600 bg-rose-50', testid: 'finance-lifetime-withdrawals' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="finance-summary-card">
      {tiles.map(({ label, value, Icon, tone, testid }) => (
        <div key={label} className="p-3 bg-white border border-gray-200 rounded-xl" data-testid={testid}>
          <div className={`inline-flex p-1.5 rounded-lg mb-1.5 ${tone}`}>
            <Icon className="w-4 h-4" />
          </div>
          <p className="text-sm font-semibold text-gray-900">{fmt(value)}</p>
          <p className="text-xs text-gray-500 truncate" title={label}>{label}</p>
        </div>
      ))}
    </div>
  );
}
